module.exports = __webpack_public_path__ + "static/img/Emerd.34fa8993.png";